import modalManager from '../modal/manager';
import { createLogger, LogLevel } from '../../utils/logger';
import { getTariffSwiperInstance } from '../../utils/swiper-integration';

const logger = createLogger('TariffModalEvents', LogLevel.INFO);

/**
 * Класс для навешивания событий на тарифную модалку
 */
export class TariffModalEvents {
  /**
   * Навешивает все события на открытую модалку
   */
  bindEvents(): void {
    const modalContent = modalManager.getModalContent();
    if (!modalContent) {
      logger.warn('modalContent не найден, события не навешаны');
      return;
    }
    logger.info('Инициализация событий для тарифной модалки');

    // Добавляем функцию для обновления data-type и href у кнопок "Выбрать"
    function updateTariffLinks(modalContent: HTMLElement, priceType: string | null) {
      const typeValue = priceType === 'all' ? 'course' : 'module';
      modalContent.querySelectorAll('.tarif__link').forEach((btn) => {
        btn.setAttribute('data-type', typeValue);
        // Меняем &type= в href
        let href = btn.getAttribute('href') || '';
        if (href.includes('&type=')) {
          href = href.replace(/([&?]type=)(course|module)/, `$1${typeValue}`);
        } else {
          href += `&type=${typeValue}`;
        }
        btn.setAttribute('href', href);
      });
    }

    // Переключатель цен (помесячно/весь курс)
    const priceSwitchers = modalContent.querySelectorAll('.header__price__switcher .switcher__item');
    priceSwitchers.forEach(btn => {
      btn.addEventListener('click', () => {
        priceSwitchers.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const priceType = btn.getAttribute('data-price');
        logger.info(`Переключение цены: ${priceType}`);
        // Ищем .tarif__price внутри всех .tarif (универсально для десктопа и мобилки)
        modalContent.querySelectorAll('.tarif .tarif__price').forEach(block => {
          const monthly = block.querySelector('.tarif__price__value.monthly-price') as HTMLElement;
          const full = block.querySelector('.tarif__price__value.full-price') as HTMLElement;
          const duration = block.querySelector('.tarif__price__duration') as HTMLElement;
          if (priceType === 'monthly') {
            if (monthly) { monthly.classList.add('active'); monthly.style.display = ''; }
            if (full) { full.classList.remove('active'); full.style.display = 'none'; }
            if (duration) duration.style.display = '';
          } else {
            if (monthly) { monthly.classList.remove('active'); monthly.style.display = 'none'; }
            if (full) { full.classList.add('active'); full.style.display = ''; }
            if (duration) duration.style.display = 'none';
          }
        });
        // Обновляем data-type и href у всех кнопок "Выбрать"
        updateTariffLinks(modalContent, priceType);
        
        // Вызываем функцию getShopCoursesById при переключении свитчера
        if (typeof (window as any).getShopCoursesById === 'function') {
          try {
            (window as any).getShopCoursesById();
            logger.info('Вызвана функция getShopCoursesById() при переключении свитчера цен');
          } catch (error) {
            logger.error('Ошибка при вызове getShopCoursesById():', error);
          }
        }
      });
    });

    // Переключение между карточками и сравнением тарифов
    // const compareBtn = modalContent.querySelector('#tarif-compare');
    // const itemsBlock = modalContent.querySelector('.tariff__items');
    // const compareBlock = modalContent.querySelector('.tariff__compare');
    // if (compareBtn && itemsBlock && compareBlock) {
    //   compareBtn.addEventListener('click', () => {
    //     const isCompare = (compareBlock as HTMLElement).style.display !== 'none';
    //     logger.info(`Переключение сравнения тарифов: ${!isCompare ? 'открыть' : 'закрыть'}`);
    //     (compareBlock as HTMLElement).style.display = isCompare ? 'none' : '';
    //     (itemsBlock as HTMLElement).style.display = isCompare ? '' : 'none';
    //     compareBtn.textContent = isCompare ? 'Сравнить тарифы' : 'Скрыть';
    //     // Добавляю/убираю класс hidden на переключателе цен
    //     const priceSwitcher = modalContent.querySelector('.header__price__switcher');
    //     if (priceSwitcher) {
    //       if (!isCompare) {
    //         priceSwitcher.classList.add('hidden');
    //       } else {
    //         priceSwitcher.classList.remove('hidden');
    //       }
    //     }
    //   });
    // }

    // Открытие "О курсе"
    const aboutBtn = modalContent.querySelector('.header__info__about');
    if (aboutBtn) {
      aboutBtn.addEventListener('click', (e) => {
      
        logger.info('Клик по кнопке "О курсе"');
        // Здесь можно реализовать переключение контента или вызов другой модалки
        // Например: modalManager.closeModal(); openAboutModal(...)
      });
    }

    // Callback (оставить заявку)
    const callbackBtn = modalContent.querySelector('[data-action="callback-modal"]');
    if (callbackBtn) {
      callbackBtn.addEventListener('click', () => {
        logger.info('Клик по кнопке callback-modal (Оставить заявку)');
        // Здесь можно реализовать открытие callback-модалки
        // Например: openCallbackModal(...)
      });
    }

    // Мобильные: переключение тарифов (свайпер)
    const tarifSwitcher = modalContent.querySelector('.header__tarif__switcher__items');
    const swiperWrapper = modalContent.querySelector('.tariff__items .swiper-wrapper');
    if (tarifSwitcher && swiperWrapper) {
      const tabs = tarifSwitcher.querySelectorAll('p[data-tarif]');
      tabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => {
          logger.info(`Переключение тарифа (мобайл): ${tab.textContent}`);
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          const swiper = getTariffSwiperInstance();
          if (swiper && typeof swiper.slideTo === 'function') {
            swiper.slideTo(idx);
          }
        });
      });
      if (tabs[0]) tabs[0].classList.add('active');
      logger.info('Инициализирован свайпер тарифов (мобайл)');
    }

    // Закрытие модалки при клике вне modal__content
    // (Оставляем только через modalManager, не через document)
    // Удаляем глобальный обработчик, если был
    // Все закрытия должны идти через modalManager
  }
}

// Экспортируем синглтон
const tariffModalEvents = new TariffModalEvents();
export default tariffModalEvents; 